import React from "react";
import { FormattedMessage } from "react-intl";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";
import VereficationStatus from "modules/shared/profiles/VereficationStatus";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "plateNumber",
        name: <FormattedMessage id="truck.plate-number" />,
        render: (item) => <b>{item}</b>,
        sortable: true,
    },
    {
        field: "model",
        name: <FormattedMessage id="truck.model" />,
        sortable: true,
    },
    {
        field: "year",
        name: <FormattedMessage id="truck.year" />,
        sortable: true,
    },
    {
        field: "qaStatus",
        name: <FormattedMessage id="entity.verification" />,
        sortable: false,
        render: (item) => <VereficationStatus status={item} />,
        width: 160,
    },
    {
        field: "createdAt",
        name: <FormattedMessage id="truck.join-date" />,
        dataType: "date",
        sortable: true,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="truck.creator.email" />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
